import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Card, CardMedia, CardContent, Typography, Box } from '@mui/material';
import * as React from 'react';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core';
import VideoDialog from './VideoDialog';
import { Colors } from '../../enums/enums';

const YOUTUBE_PLAYLIST_ITEMS_API = 'https://www.googleapis.com/youtube/v3/playlistItems';

const useStyles = makeStyles({
  root: {
    width: '350px',
    height: '270px',
    marginBottom: '30px',
    transition: 'transform 0.15s ease-in-out',
    '&:hover': { transform: 'scale3d(1.05, 1.05, 1)', cursor: 'pointer' }
  },
  link: {
    display: 'block',
    margin: '0 10px'
  }
});

export default function VideoMediaCarousel() {
  const classes = useStyles();

  const [data, setData] = useState({ items: [] });
  const [openVideoDialog, setOpenVideoDialog] = useState(false);
  const [videoId, setVideoId] = useState('');

  useEffect(() => {
    axios
      .get(
        `${YOUTUBE_PLAYLIST_ITEMS_API}?playlistId=PLN2xt9HyWoMp2p0smViEEgJIQx9g5Yn8P&part=snippet,id&maxResults=40&key=${process.env.REACT_APP_YOUTUBE_API_KEY}`
      )
      .then((res) => {
        setData(res.data);
        console.log(data);
      });
  }, []);

  const responsive = {
    largeDesktop: {
      breakpoint: { max: 4000, min: 2100 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 2100, min: 1700 },
      items: 4
    },
    smallDesktop: {
      breakpoint: { max: 1700, min: 1300 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1300, min: 800 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 800, min: 0 },
      items: 1
    }
  };

  const handleClose = () => {
    setOpenVideoDialog(false);
  };

  return (
    <Box sx={{ mr: '120px', mt: '30px' }}>
      <Carousel
        containerClass="container"
        responsive={responsive}
        infinite={true}
        autoPlay={true}
        draggable={false}
        autoPlaySpeed={4000}
      >
        {data.items.map((item) => (
          <Card
            sx={{ boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px 0px, rgba(0, 0, 0, 0.3) 0px 2px 3px -1px' }}
            key={item.id}
            className={classes.root}
            onClick={() => {
              setVideoId(item?.snippet.resourceId.videoId);
              setOpenVideoDialog(true);
            }}
          >
            <CardMedia
              component="img"
              image={
                item.snippet.thumbnails?.maxres?.url ||
                `https://img.youtube.com/vi/${item?.snippet.resourceId.videoId}/maxresdefault.jpg`
              }
            />
            <CardContent sx={{ backgroundColor: Colors.BackgroundDrawer }}>
              <Typography variant="body2" color="text.secondary">
                VIDEO
              </Typography>
              <Typography gutterBottom variant="h6" component="div" sx={{ color: Colors.TextElevated }}>
                {item.snippet.title}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Carousel>
      <VideoDialog isOpen={openVideoDialog} handleClose={handleClose} videoId={videoId} />
    </Box>
  );
}
